function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../../utils/classNames';
var cx;
/**
 * The Scrim component provides a focused experience for the user
 * when presented with a singular task (as in a modal). It will grey
 * out background content. The functionality of ths component is driven by
 * the `@sie/web-common-layers` package and although can be used alone the
 * `UiLayers` component should be preferred as it provides a more complete integration
 * with that package.
 *
 * - [Web Common Layers Docs](https://github.sie.sony.com/pages/SIE/web-common-toolkit/core/layers/)
 *
 * ## Related Components
 * - [UiLayers](../../UiLayers/README.md)
 *
 * ## Props
 */

var Scrim = /*#__PURE__*/function (_PureComponent) {
  _inherits(Scrim, _PureComponent);

  var _super = _createSuper(Scrim);

  function Scrim(props) {
    var _this;

    _classCallCheck(this, Scrim);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      elevation: 0,
      isVisible: false
    });

    _defineProperty(_assertThisInitialized(_this), "_prepDocument", function (_ref) {
      var isVisible = _ref.isVisible;
      if (_this._hasPswRoot) return;
      var htmlEl = document.querySelector('html');

      if (isVisible) {
        htmlEl.classList.add('psw-root');
      } else {
        htmlEl.classList.remove('psw-root');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_setPageScrollbarVisibility", function (_ref2) {
      var isVisible = _ref2.isVisible;
      var htmlEl = document.querySelector('html');
      var bodyEl = document.body;

      if (isVisible) {
        htmlEl.classList.add('psw-no-scroll');
        bodyEl.classList.add('psw-no-scroll');
      } else {
        htmlEl.classList.remove('psw-no-scroll');
        bodyEl.classList.remove('psw-no-scroll');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_blurElement", function (_ref3) {
      var el = _ref3.el,
          id = _ref3.id,
          elevation = _ref3.elevation,
          isVisible = _ref3.isVisible;
      var isScrimEl = el.classList.contains('psw-layer-scrim');
      var isActiveEl = el.dataset.layerItemId === id;

      if (!isVisible || isActiveEl) {
        el.classList.remove('psw-blur-out');
        return;
      }

      var elElevation = parseInt(el.style.zIndex || 0, 10);

      if (!isScrimEl && elevation >= elElevation) {
        el.classList.remove(isVisible ? 'psw-focus-in' : 'psw-blur-out');
        el.classList.add(isVisible ? 'psw-blur-out' : 'psw-focus-in');
      }
    });

    _this._node = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(Scrim, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var scrim = this.props.scrim;
      this._hasPswRoot = document.querySelector('html').classList.contains('psw-root');
      this._isFirefox = document.querySelector('html').dataset.browser === 'FIREFOX';
      this.off = scrim.on('update', function (_ref4) {
        var elevation = _ref4.elevation,
            isVisible = _ref4.isVisible,
            id = _ref4.id;

        _this2._prepDocument({
          isVisible: isVisible
        });
        /**
         * Firefox is the only browser in our support matrix which does not support
         * the CSS property backdrop-filter which would provide the blur effect to all content
         * below it.
         */


        if (_this2._isFirefox) {
          _this2._blurWhen({
            isVisible: isVisible,
            id: id,
            elevation: elevation
          });
        }

        _this2._setPageScrollbarVisibility({
          isVisible: isVisible
        });

        _this2.setState({
          elevation: elevation,
          isVisible: isVisible
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        elevation: 0,
        isVisible: false
      });

      if (typeof this.scrim === 'function') {
        this.off();
      }
    }
  }, {
    key: "_getAllElsToBlur",
    value: function _getAllElsToBlur() {
      var parentEl = this._node.current.parentElement;
      var grandParentEl = parentEl.parentElement || {
        children: []
      };
      var ancestorsToBlur = [];

      if (parentEl !== document.body) {
        ancestorsToBlur = _toConsumableArray(grandParentEl.children).filter(function (el) {
          return el !== parentEl && el.tagName !== 'SCRIPT';
        });
      }

      return _toConsumableArray(parentEl.children).concat(ancestorsToBlur);
    }
    /**
     * Adding a filter to an element blurs all of it's content. To get the
     * content blur effect that design wants we need to find all of the elements which
     * may have content and apply the blur to them without also blurring the content that
     * is to be showed in the active layer.
     */

  }, {
    key: "_blurWhen",
    value: function _blurWhen(_ref5) {
      var _this3 = this;

      var isVisible = _ref5.isVisible,
          id = _ref5.id,
          elevation = _ref5.elevation;

      var allElsToBlur = this._getAllElsToBlur();

      allElsToBlur.forEach(function (el) {
        return _this3._blurElement({
          el: el,
          id: id,
          elevation: elevation,
          isVisible: isVisible
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          elevation = _this$state.elevation,
          isVisible = _this$state.isVisible;

      var _Scrim$getClassName = Scrim.getClassName({
        isVisible: isVisible
      }),
          root = _Scrim$getClassName.root;

      return /*#__PURE__*/React.createElement("div", {
        ref: this._node,
        "data-qa": "layers#scrim",
        className: root,
        style: {
          zIndex: elevation
        }
      });
    }
  }]);

  return Scrim;
}(PureComponent);

_defineProperty(Scrim, "getClassName", function () {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isVisible = _ref6.isVisible;

  return {
    root: cx('psw-layer-scrim', 'psw-scrim', 'psw-l-full-screen', "psw-pointer-events-".concat(isVisible ? 'on' : 'off'), {
      'psw-is-active': isVisible
    })
  };
});

_defineProperty(Scrim, "useClassNames", function (classNames) {
  Scrim.classNames = classNames;
});

Scrim.propTypes = {
  /**
   * Scrim object from layers library
   */
  scrim: PropTypes.shape({
    /**
     * method to notify component of scrim updates
     */
    on: PropTypes.func
  }).isRequired
};
cx = classNamesFor(Scrim);
export default Scrim;